
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/smart-chains/tutorials/smart-chain-api-basics",
      function () {
        return require("private-next-pages/docs/smart-chains/tutorials/smart-chain-api-basics/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/smart-chains/tutorials/smart-chain-api-basics"])
      });
    }
  